import {copilot} from '@cl/shared';
import {CLDispatch} from 'common/src/redux/store';
import {AgentName} from '../../copilot.enums';
import {createChat as createChatAction} from '../copilot.slice';
import addWelcomeMessage from './utils/addWelcomeMessage';

function createChat() {
  return (dispatch: CLDispatch) => {
    const chat = copilot.createChat();
    const chatId = chat.id;

    dispatch(createChatAction({chatId, isPlanModeEnabled: true}));
    addWelcomeMessage(dispatch, chatId, AgentName.General);

    return chatId;
  };
}

export default createChat;
